import { TABLE_PROPS } from "@desk/app.constant";
import { Button, Card, DatePicker, Row, Table } from "antd";

const StrandedList = () => {
  const tableHeader = () => (
    <Row justify="end">
      <DatePicker.RangePicker />
      <Button type="primary">搜索</Button>
    </Row>
  );
  return (
    <Card>
      {/* prettier-ignore */}
      <Table {...TABLE_PROPS} dataSource={[{}]} title={tableHeader}>
        <Table.Column dataIndex="name" title="序号" align="center" />
        <Table.Column dataIndex="name" title="快递单号" align="center" />
        <Table.Column dataIndex="name" title="箱子名称" align="center" />
        <Table.Column dataIndex="name" title="箱子序列号（SN）" align="center" />
        <Table.Column dataIndex="name" title="包裹状态" align="center" />
        <Table.Column dataIndex="name" title="快递公司投递时间" align="center" />
        <Table.Column dataIndex="name" title="有效期限" align="center" />
        <Table.Column dataIndex="name" title="取件方式" align="center" />
        <Table.Column dataIndex="name" title="取件人取出时间" align="center" />
        <Table.Column dataIndex="name" title="存放时长" align="center" />
      </Table>
    </Card>
  );
};

export default StrandedList;
